exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checked[data-v-375e2696]{color:tomato}.purchase[data-v-375e2696]{font-family:Oswald,sans-serif;font-weight:400;text-transform:uppercase;padding:.85rem .5rem;min-width:115px;z-index:2}.purchase span[data-v-375e2696]{display:block}.component-actions[data-v-375e2696]{margin-bottom:unset!important}.add-cart[data-v-375e2696]:before{margin-left:.5rem;margin-top:2px}.add-cart span[data-v-375e2696]{margin-left:-.2rem}", ""]);

// exports
